import { render, staticRenderFns } from "./Book2.vue?vue&type=template&id=0520059c&scoped=true&"
import script from "./Book2.vue?vue&type=script&lang=js&"
export * from "./Book2.vue?vue&type=script&lang=js&"
import style0 from "./Book2.vue?vue&type=style&index=0&id=0520059c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0520059c",
  null
  
)

export default component.exports